import { render, staticRenderFns } from "./AreaShop.vue?vue&type=template&id=4045da12&scoped=true&"
import script from "./AreaShop.vue?vue&type=script&lang=ts&"
export * from "./AreaShop.vue?vue&type=script&lang=ts&"
import style0 from "./AreaShop.vue?vue&type=style&index=0&id=4045da12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045da12",
  null
  
)

export default component.exports